FfnManagementNumberValidator.DIRECTIVE_NAME = 'ktFfnManagementNumberValidator';

export default function FfnManagementNumberValidator() {
    return {
        restrict: 'A',
        require: ['^ktFfnManagement', 'ngModel'],
        link: function($scope, $elem, $attrs, controllers) {
            const [ffnManagementCtrl, ngModelCtrl] = controllers;
            const validators = ngModelCtrl.$validators;
            validators.duplicate = () => !ffnManagementCtrl.model.map((ffn) => ffn.Ffn).includes(ffnManagementCtrl.editedItem.number);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/ffn-management/ffn-management-number-validator.js